import React from 'react';
import axios from 'axios';
import { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Password(props) {
    const [inputField, setInputField] = useState({ password: '', cpassword: '' });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputField(prev => ({ ...prev, [name]: value }));
    };

    const formSubmit = (e) => {
        e.preventDefault();
        if (inputField.password !== inputField.cpassword) {
            alert("Passwords don't match");
            return;
        }
        if (inputField.password.length < 6) {
            alert("Password must be at least 6 characters");
            return;
        }

        setIsLoading(true);
        axios.post('https://singlewindowsecurities.com/rest3/change_password_api/' + localStorage.getItem('userid'), 
            { password: inputField.password })
            .then((res) => {
                alert("Password updated successfully!");
                navigate('/settings');
            })
            .catch((err) => {
                alert("Error updating password");
                console.error(err);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="safearea bg-soft">
            <Helmet>
                <title>Change Password</title>
            </Helmet>

            {/* Modern Header */}
            <header className="app-header bg-primary text-white shadow-sm">
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn btn-ghost-light me-2">
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0">Change Password</h1>
                    </div>
                </div>
            </header>

            <main className="container py-4 mt-5">
                <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
                    <div className="card-body p-4">
                        <form onSubmit={formSubmit}>
                               
                                <div className="form-group">
                                     <label htmlFor="password" className="form-label fw-medium text-muted">
                                    New Password
                                </label>
                                <small className="text-muted">Minimum 6 characters</small>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        value={inputField.password}
                                        onChange={handleChange}
                                        className="form-control form-control-lg border-2"
                                        placeholder="••••••••"
                                        required
                                    />
                                    
                                </div>

                             
                                <div className="form-group">
                                      <label htmlFor="cpassword" className="form-label fw-medium text-muted">
                                    Confirm Password
                                </label>
                                    <input
                                        type="password"
                                        id="cpassword"
                                        name="cpassword"
                                        value={inputField.cpassword}
                                        onChange={handleChange}
                                        className="form-control form-control-lg border-2"
                                        placeholder="••••••••"
                                        required
                                    />
                                   
                                </div>
                        

                            <button
                                type="submit"
                                className="btn btn-primary btn-sm w-100 py-3 mt-3 fw-bold"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                ) : (
                                    'Update Password'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
}